import { SET_ART_WALL_SCREENSHOT_STATUS } from './../const';

export default (artWallScreenshotStatus) => {
  return {
    type: SET_ART_WALL_SCREENSHOT_STATUS,
    artWallScreenshotStatus: artWallScreenshotStatus
  }
};
